import { AnytimeTemplatesPage } from "@/features/anytime/pages/AnytimeTemplates";
import React from "react";

const AnytimeTemplates = () => {
  return <AnytimeTemplatesPage />;
};

export default AnytimeTemplates;
